import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { loadEmployee } from '../../employees/actions/load-employee';
import { setSurveyResponsesDirty } from '../../employees/actions/survey/set-survey-responses-dirty';
import { employeeSelector } from '../../reducers/employee-selectors';

import { surveysRoute } from '../../web-routes';

import { RealTimeNotification } from './real-time-notification';

import { employeeName } from '../../employees/utils/employee-name';

const mapStateToProps = (state: any, ownProps: InputProps) => ({
  employee: employeeSelector(state, ownProps.employeeId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadEmployee: () => dispatch(loadEmployee(ownProps.employeeId)),
  },
});

type InputProps = {
  employeeId: number;
  message: Message;
  onClose: () => void;
};

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & ReduxProps & DispatchProps & RouteComponentProps;

export const prepareSurveyResponseNotificationData = async (surveyId: number, store: any) => {
  await store.dispatch(setSurveyResponsesDirty(surveyId));
};

export const SurveyResponseNotification = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(({ employee, message, onClose, history, actions }: Props) => {
    useEffect(() => {
      actions.loadEmployee();
    });

    if (!employee || !message.surveyId) {
      return null;
    }

    const surveyResponseRoute = surveysRoute(employee.orgId, message.surveyId);

    const handleViewClick = () => {
      history.push(surveyResponseRoute);
      onClose();
    };

    return (
      <RealTimeNotification
        title={`Survey response from ${employeeName(employee)}`}
        messageBody={message.messageBody}
        subtitle={employee.jobTitle || ''}
        onClose={onClose}
        // IF (01/22/20): If the user is already viewing the responses, don't show the link
        actions={
          window.location.pathname === surveyResponseRoute ? null : (
            <div role="presentation" className="u-margin-top typo-link" onClick={handleViewClick}>
              View Survey Responses
            </div>
          )
        }
      />
    );
  }),
);
